import * as React from 'react';
import * as style from './style.css';
import { IconClock16, UIHeading2 } from '@cian/ui-kit';
import { Phone16 } from '@cian/ui-kit/prev';

interface ISinglePhoneProps {
  availability: string;
  phone: string;
}

export const SinglePhone = ({ phone, availability }: ISinglePhoneProps) => {
  return (
    <div className={style['container']}>
      <UIHeading2>{phone}</UIHeading2>
      {availability && (
        <div className={style['info']}>
          <div className={style['icon']}>
            <IconClock16 />
          </div>
          <span>{availability}</span>
        </div>
      )}
      <div className={style['info']}>
        <div className={style['icon']}>
          <Phone16 />
        </div>
        <span>Номер только для звонков, сообщения не дойдут</span>
      </div>
    </div>
  );
};
